import React, { Fragment, useEffect, useState } from "react";
import { Row, Col, Card, Table, Form } from "react-bootstrap";
import { Tooltip, IconButton } from "@mui/material";
import { FaRegCopy } from "react-icons/fa";
import axios from "axios";
import toast from "react-hot-toast";
import { URLApi } from "../../../services/api_function";

function IncomeReport() {
  const itemsPerPage = 10;
  const [apiData, setApiData] = useState([]);
  const [totalUsers, setTotalUsers] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState("");
  const [tooltipText, setTooltipText] = useState("Copy address");
  const [filteredData, setFilteredData] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [loading, setLoading] = useState(true);
  const [incomeType, setIncomeType] = useState("1"); // Default to Binary: 1
  
  // Income type options
  const incomeTypes = [
    { value: "0", label: "Sponsor Income" },
    { value: "1", label: "Binary" },
    { value: "2", label: "Yield" },
    { value: "3", label: "Level" },
    // { value: "4", label: "Flush Income" }
  ];

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const userDetails = localStorage.getItem("adminToken");
        const token = userDetails;
        
        // Build query parameters
        // const params = new URLSearchParams({
        //   page: currentPage,
        //   limit: itemsPerPage,
        //   incomeType: incomeType
        // });
        
        // if (search && isSearching) {
        //   params.append('search', search);
        // }

        const response = await axios.get(
          `${URLApi}/incomeList`,
          {
            params: { type: incomeType }
          }
        );
        console.log(response, "API Response");
        
        if (response.status === 200) {
          setApiData(response?.data?.data || []);
          setTotalUsers(response?.data?.pagination?.total || 0);
          setTotalPages(response?.data?.pagination?.totalPages || 1);
        }
      } catch (error) {
        toast.error("Failed to fetch data.");
        console.error("Error fetching income data:", error);
      } finally {
        setLoading(false);
      }
    };
    
    fetchData();
  }, [currentPage, incomeType]);

  const handleSearch = async (e) => {
    const query = e.target.value.trim().toLowerCase();
    const sanitizedQuery = query.replace(/[\\|^$*+?.(){}[\]]/g, "");
    setSearch(sanitizedQuery);

    if (query === "") {
      setIsSearching(false);
      setFilteredData([]);
    } else {
      const results = apiData.filter((item) =>
        item.randomUserAddress?.toLowerCase().includes(query) ||
        item.randomRefferarAddress?.toLowerCase().includes(query)
      );
      setFilteredData(results);
      setIsSearching(true);
    }

    if (currentPage !== 1) {
      setCurrentPage(1);
    }
  };

  const handleCopy = (address) => {
    navigator.clipboard.writeText(address);
    setTooltipText("Copied!");
    setTimeout(() => setTooltipText("Copy address"), 2000);
  };

  const handleIncomeTypeChange = (e) => {
    setIncomeType(e.target.value);
    setCurrentPage(1); // Reset to first page when filter changes
  };

  const handleNextPage = () => {
    setCurrentPage((prevPage) =>
      prevPage < totalPages ? prevPage + 1 : prevPage,
    );
  };

  const handlePreviousPage = () => {
    setCurrentPage((prevPage) => (prevPage > 1 ? prevPage - 1 : prevPage));
  };

  const displayData = isSearching ? filteredData : apiData;

  return (
    <Fragment>
      <Row>
        {/* Search and Filter Section */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div className="input-group" style={{ maxWidth: "300px" }}>
            <input
              type="search"
              id="form1"
              className="form-control"
              placeholder="Search by User/Referral Address..."
              onChange={handleSearch}
              value={search}
            />
          </div>
          
          <div className="d-flex align-items-center gap-3">
            <Form.Group controlId="incomeTypeFilter" className="mb-0">
              <Form.Label className="me-2 text-light">Income Type:</Form.Label>
              <Form.Select
                value={incomeType}
                onChange={handleIncomeTypeChange}
                style={{ minWidth: "180px" }}
              >
                {incomeTypes.map((type) => (
                  <option key={type.value} value={type.value}>
                    {type.label}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </div>
        </div>

        <Col lg={12}>
          <Card>
            <Card.Header>
              <Card.Title className="text-light">Income Report</Card.Title>
            </Card.Header>
            <Card.Body>
              {loading ? (
                <div className="text-center py-5">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <p className="mt-2">Loading income data...</p>
                </div>
              ) : (
                <>
                  <Table
                    responsive
                    className="table table-bordered table-striped table-hover"
                  >
                    <thead>
                      <tr>
                        <th>S.No.</th>
                        <th>User Address</th>
                        <th>From Address</th>
                        <th>Income Type</th>
                        <th>Income Amount</th>
                        <th>Status</th>
                        <th>Date & Time</th>
                      </tr>
                    </thead>
                    <tbody>
                      {displayData?.length === 0 ? (
                        <tr>
                          <td colSpan="7" className="text-center">
                            No Records Found
                          </td>
                        </tr>
                      ) : (
                        displayData?.map((data, index) => {
                          const incomeTypeLabel = incomeTypes.find(
                            type => type.value === data?.incomeType?.toString()
                          )?.label || "Unknown";
                          
                          return (
                            <tr key={index}>
                              <td>{index + 1 + (currentPage - 1) * itemsPerPage}</td>
                              <td>
                                {data?.user
                                  ? `${data.user.slice(0, 6)}...${data.user.slice(-4)}`
                                  : "N/A"}
                                <Tooltip title={tooltipText} arrow>
                                  <IconButton
                                    onClick={() => handleCopy(data?.user)}
                                    size="small"
                                    style={{ marginLeft: 4 }}
                                  >
                                    <FaRegCopy />
                                  </IconButton>
                                </Tooltip>
                              </td>
                               <td>
                                {data?.from
                                  ? `${data.from.slice(0, 6)}...${data.from.slice(-4)}`
                                  : "N/A"}
                                <Tooltip title={tooltipText} arrow>
                                  <IconButton
                                    onClick={() => handleCopy(data?.from)}
                                    size="small"
                                    style={{ marginLeft: 4 }}
                                  >
                                    <FaRegCopy />
                                  </IconButton>
                                </Tooltip>
                              </td>
                              <td className="d-flex align-items-center justify-content-center">
                                <span className="badge bg-info">
                                  {data?.incomeType}
                                </span>
                              </td>
                              <td>
                                ${data?.usdAmount?.toFixed(2) || "0.00"}
                              </td>
                              <td>
                                <span className="badge bg-success">
                                  Completed
                                </span>
                              </td>
                              <td>
                                {data?.timestamps
                                  ? new Date((data?.timestamps) * 1000).toLocaleString("en-GB")
                                  : "N/A"}
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </Table>

                  {/* Pagination */}
                  {!isSearching && (
                    <div
                      className="text-center mb-3 col-lg-6"
                      style={{ margin: "auto" }}
                    >
                      <div className="filter-pagination mt-3">
                        <button
                          className="previous-button btn border m-2"
                          onClick={handlePreviousPage}
                          disabled={currentPage === 1 || loading}
                        >
                          Previous
                        </button>

                        <button
                          className="next-button btn btn-success pointer border m-2"
                          onClick={handleNextPage}
                          disabled={currentPage === totalPages || loading}
                        >
                          Next
                        </button>

                        <span>
                          Page {currentPage} of {totalPages}
                        </span>
                        <span> Total Records: {totalUsers}</span>
                      </div>
                    </div>
                  )}
                </>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Fragment>
  );
}

export default IncomeReport;